var exports = {
  "iE": "wrapper__rjK5E1",
  "Qs": "content__Gga5Vm",
  "Zp": "layout__i0tp-u",
  "pz": "sidebar__wcVu82",
  "nd": "panel__DOwr-P",
  "$r": "panelIcons__cgfts0",
  "Wi": "panelIcon__pGMmpQ",
};

module.exports = exports;
